import { Alert, BannerAlertType, } from '@thoughtspot/radiant-react/widgets/alert';
import { Horizontal, Vertical, } from '@thoughtspot/radiant-react/widgets/layout';
import { Typography } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import styles from './base-component.container.module.scss';
export const BaseComponentContainer = ({ id, title, description, children, container, renderActionButton, error, }) => {
    const { errorBanner = false, errorBannerMessage = '', hideErrorBanner, } = error;
    return (React.createElement(Vertical, null,
        errorBanner && (React.createElement(Alert.Banner, { message: errorBannerMessage, isVisible: true, type: BannerAlertType.ERROR, onClose: hideErrorBanner })),
        React.createElement(Vertical, { "data-testid": `${id}-component`, className: cx(styles.container, {
                [styles.adminContainerWithoutSpace]: container,
            }) },
            title && (React.createElement(Vertical, { className: styles.homeContentWrapper, spacing: "g" },
                React.createElement(Vertical, { "data-testid": `${id}-header`, spacing: "b" },
                    React.createElement(Vertical, null,
                        React.createElement(Horizontal, { className: styles.titleWrapper },
                            React.createElement(Typography, { variant: "page-title", noMargin: true }, title),
                            renderActionButton && renderActionButton())),
                    React.createElement(Vertical, null,
                        React.createElement(Typography, { variant: "content-label-subhead", noMargin: true }, description))))),
            React.createElement(Horizontal, { column: true, className: styles.contentHeight }, children))));
};
//# sourceMappingURL=base-component.container.js.map